<div class="container mx-auto px-4 py-6">
  <div class="mb-6 flex items-center justify-between">
    <div>
      <h1 class="text-3xl font-bold text-gray-800">Banners</h1>
      <p class="text-gray-600 mt-2">Gestão de banners (ads)</p>
    </div>
    <a routerLink="/admin/config/banners/new" class="px-4 py-2 bg-green-600 text-white rounded-md">Novo Banner</a>
  </div>

  <div class="bg-white rounded-lg shadow p-6 mb-6">
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Nome</label>
        <input [(ngModel)]="filtroNome" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="Buscar por nome">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Localização</label>
        <select [(ngModel)]="filtroLocalizacao" class="w-full px-3 py-2 border border-gray-300 rounded-md">
          <option value="">Todas</option>
          <option *ngFor="let l of localizacoes" [value]="l">{{ l }}</option>
        </select>
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Ativo</label>
        <select [(ngModel)]="filtroAtivo" class="w-full px-3 py-2 border border-gray-300 rounded-md">
          <option value="">Todos</option>
          <option value="true">Ativo</option>
          <option value="false">Inativo</option>
        </select>
      </div>
      <div class="flex items-end">
        <button (click)="load()" class="px-4 py-2 bg-blue-600 text-white rounded-md">Filtrar</button>
        <button (click)="resetFilters()" class="ml-2 px-4 py-2 border rounded-md">Limpar</button>
      </div>
    </div>
  </div>

  <div *ngIf="loading" class="flex justify-center items-center py-12">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading" class="bg-white rounded-lg shadow overflow-hidden">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nome</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Localização</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Imagem</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Link</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ordem</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ativo</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let b of items" class="hover:bg-gray-50">
            <td class="px-6 py-4">
              <div class="text-sm font-medium text-gray-900">{{ b.title || b.nome }}</div>
              <div class="text-xs text-gray-500">ID: {{ b.id }}</div>
            </td>
            <td class="px-6 py-4">{{ b.description || b.localizacao }}</td>
            <td class="px-6 py-4"><a [href]="b.imageUrl" target="_blank" class="text-blue-600 hover:underline">Abrir</a></td>
            <td class="px-6 py-4">
              <a *ngIf="b.linkUrl || b.linkDestino" [href]="b.linkUrl || b.linkDestino" target="_blank" class="text-blue-600 hover:underline">{{ b.linkUrl || b.linkDestino }}</a>
              <span *ngIf="!b.linkUrl && !b.linkDestino" class="text-gray-400">—</span>
            </td>
            <td class="px-6 py-4">{{ b.displayOrder || b.order || 0 }}</td>
            <td class="px-6 py-4">
              <span [class]="'px-2 inline-flex text-xs leading-5 font-semibold rounded-full ' + ((b.isActive || b.ativo) ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800')">
                {{ (b.isActive || b.ativo) ? 'Ativo' : 'Inativo' }}
              </span>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium space-x-2">
              <button (click)="edit(b)" class="text-blue-600 hover:text-blue-900">Editar</button>
              <button (click)="remove(b)" class="text-red-600 hover:text-red-900">Remover</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="bg-white px-4 py-3 border-t border-gray-200 sm:px-6">
      <div class="flex items-center justify-between">
        <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
          <div>
            <p class="text-sm text-gray-700">
              Mostrando
              <span class="font-medium">{{ (page - 1) * pageSize + 1 }}</span>
              até
              <span class="font-medium">{{ displayEnd() }}</span>
              de
              <span class="font-medium">{{ total }}</span>
              resultados
            </p>
          </div>
          <div>
            <app-pagination [page]="page" [pageSize]="pageSize" [total]="total" (pageChange)="onPageChange($event)"></app-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
